import createDependenciesScope from '@/scopes/common/infrastructure/dependencies/createDependenciesScope';
import type { AnalyticsClient, EnvType, FeatureFlagsStore } from '../../domain/types';
import { type RelativePastTimeResolver } from '@/intl/relativePastTimeResolver';
import type { StoreApi } from 'zustand';
import type { PriceDetailsApiClient } from '@/scopes/common/infrastructure/price-details/api/types';
import type { createQueryStringClient } from '@/scopes/common/infrastructure/query-strings/queryStringClient';

export interface Common {
  env: EnvType;
  relativePastTimeResolver: RelativePastTimeResolver;
  analyticsClient: AnalyticsClient;
  featureFlagsStore: StoreApi<FeatureFlagsStore>;
  priceDetailsApiClient: PriceDetailsApiClient;
  queryStringClient: ReturnType<typeof createQueryStringClient>;
}

const { Provider, useDependency } = createDependenciesScope<Common>();

export const CommonDependenciesProvider = Provider;
export const useCommonDependency = useDependency;
